import React from "react";

import Goals from "./Goals";
import CenterImage from "./CenterImage";
import ImageColumn from "./ImageColumn";
import TextBlock from "./TextBlock";
import NumberColumn from "./NumberColumn";
import ProblemSolution from "./ProblemSolution";
import CTA from "../CTA";
import LinkColumn from "./LinkColumn";

const PageGenerator = ({ schema }) => {
    return (
        <section className="project-page">
            {schema && schema.map((section, key) => {
                switch (section.type) {
                    case 'goals':
                        return <Goals key={key} listOfGoals={section.list} />
                    case 'centered-image':
                        return <CenterImage
                                    key={key}
                                    image={section.url}
                                    title={section.title}
                                    caption={section.caption}
                                    width={section.width}
                                    rounded={section.rounded} />
                    case 'image-column':
                        return <ImageColumn
                                    key={key}
                                    image={section.url}
                                    caption={section.caption}
                                    content={section.content}
                                    flip={section.flip && section.flip}
                                    equal={section.equal && section.equal}
                                    width={section.width}
                                    rounded={section.rounded} />
                    case 'text-block':
                        return <TextBlock
                                    key={key}
                                    title={section.title}
                                    anchor={section.anchor}
                                    content={section.content}
                                    background={section.background}
                                    gold={section.gold} />
                    case 'number-column':
                        return <NumberColumn
                                    key={key}
                                    title={section.title}
                                    list={section.list} />
                    case 'problem-solution':
                        return <ProblemSolution
                                    key={key}
                                    problems={section.problems}
                                    solutions={section.solutions} />
                    case 'cta':
                        return <CTA
                                    key={key}
                                    title={section.title}
                                    content={section.content}
                                    link={section.link} />
                    case 'link-column':
                        return <LinkColumn
                                    key={key}
                                    link={section.link}
                                    caption={section.caption}
                                    content={section.content}
                                    flip={section.flip && section.flip}
                                    equal={section.equal && section.equal} />
                    default:
                        return <></>
                }
            })}
        </section>
    )
};

export default PageGenerator;